import axios, { AxiosResponse } from 'axios'
import {WebLoginResponseModel, BaseResponseModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `${API_URL}/LoginServlet`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/ApplicantForgetPasswordServlet`

// Server should return AuthModel


// Server should return AuthModel
export function register(
    email: string,
    firstname: string,
    lastname: string,
    password: string,
    password_confirmation: string
) {
    return axios.post(REGISTER_URL, {
        email,
        first_name: firstname,
        last_name: lastname,
        password,
        password_confirmation,
    })
}


export function callLogout() {
    return axios.post(`${API_URL}/LogoutServlet`)
}

export function userLogin(email: string, password: string) {    
    // return axios.post<SetscoLoginResponse>(`${API_URL}/LoginServlet?username=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`)
    /*
    return axios.request({
        method: 'post',
        url: `${API_URL}/LoginServlet?username=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`,
        withCredentials: false
    })
    */
    return axios.request({
      method: 'post',
      url: `${API_URL}/LoginServlet`,
      data: { username: email, password },
      withCredentials: false
    })
    .then((d: AxiosResponse<WebLoginResponseModel>) => d.data)    
}

export function userValidateOTP(email: string, password: string, otp: string) {    
    /*
    return fetch(        
        `${API_URL}/OTPServlet?username=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}&otp=${encodeURIComponent(otp)}`,
        {
            method: 'post',            
            credentials: 'include',
        }
    )
    */
    return fetch(        
      `${API_URL}/OTPServlet`,
      {
          method: 'post',            
          credentials: 'include',
          body: JSON.stringify({ username: email, password, otp })
      }
    )
    .then(response => {
        if (!response.ok) {
            throw new Error(response.statusText)
        }
        return response.json() as Promise<WebLoginResponseModel>
    })

}


export function userRequestPassword(email: string) {    
    return axios.request({
        method: 'post',
        url: `${API_URL}/ForgetPasswordServlet`,
        data: { username: email },
        withCredentials: false
    })
    .then((d: AxiosResponse<WebLoginResponseModel>) => d.data)    
}

export function userValidateForgetPasswordOTP(username: string, otp: string, password: string): Promise<BaseResponseModel> {    
    
    return fetch(        
        `${API_URL}/ForgetPasswordOTPServlet`,                
        {
            method: 'post',            
            credentials: 'include',
            body: JSON.stringify({ username, password, otp })
        }
    )
    .then(response => {
        if (!response.ok) {
            throw new Error(response.statusText)
        }
        return response.json() as Promise<BaseResponseModel>
    })    
}


export function companyOnboarding(data : any) {
    return axios.post(`${API_URL}/OnBoardingServlet`, data)
}

export function companyValidateOnboardOTP(id: number, otp: string) {    
    return axios.post( `${API_URL}/OnBoardingOTPServlet`, { id, otp })
}

export const applicantLogin = (email: string, password: string) : Promise<WebLoginResponseModel | undefined> => {    
    return axios.request({
        method: 'post',
        url: `${API_URL}/ApplicantLoginServlet`,
        data: { username: email, password },
        withCredentials: false

    }) 
    .then((d: AxiosResponse<WebLoginResponseModel>) => d.data)    
}

export function applicantValidateOTP(email: string, password: string, otp: string) {    

    return fetch(        
        `${API_URL}/ApplicantOTPServlet`,                
        {
            method: 'post',            
            credentials: 'include',
            body: JSON.stringify({ username: email, password, otp })
        }
    )
    .then(response => {
        if (!response.ok) {
            throw new Error(response.statusText)
        }
        return response.json() as Promise<WebLoginResponseModel>
    })    
}


export function applicantRequestPasswordReset(email: string) {    
    return axios.request({
        method: 'post',
        url: `${API_URL}/ApplicantForgetPasswordServlet`,
        data: { username: email },
        withCredentials: false
    })
    .then((d: AxiosResponse<WebLoginResponseModel>) => d.data)        
}

export function applicantValidateForgetPasswordOTP(username: string, otp: string, password: string): Promise<BaseResponseModel> {    
    
    return fetch(        
        `${API_URL}/ApplicantForgetPasswordOTPServlet`,                
        {
            method: 'post',            
            credentials: 'include',
            body: JSON.stringify({ username, password, otp })
        }
    )
    .then(response => {
        if (!response.ok) {
            throw new Error(response.statusText)
        }
        return response.json() as Promise<BaseResponseModel>
    })    
}


export function applicantGetRecord() {
    // get record of logged in user
    return axios.get<UserModel>(`${API_URL}/ApplicantByIdServlet`)
}

export function applicantGetRecordByID(id : number) {
    // get record of logged in user
    return axios.post<UserModel>(`${API_URL}/ApplicantByIdServlet`,  id, { headers: { "Content-Type": "text/plain" }} )
}

